/*
 * Pip — the fawn mascot.
 * Silent hops on every page; tiny text only at key moments (add-to-cart, 404).
 * No external dependencies. Respects prefers-reduced-motion and a dismiss preference.
 */
(function () {
  var root = document.getElementById('fawn-mascot');
  if (!root) return;

  try {
    if (localStorage.getItem('fawn-mascot-hidden') === '1') { root.remove(); return; }
  } catch (e) {}

  var pipEl = root.querySelector('.pip');
  var bubble = root.querySelector('.pip__bubble');
  var closeBtn = root.querySelector('.pip__close');
  var pageType = root.getAttribute('data-page-type') || '';
  var homeUrl = root.getAttribute('data-home-url') || '/';

  var hideTimer, idleTimer;
  var lastCount = readCartCount();

  function readCartCount() {
    var el = document.querySelector('cart-icon [ref="cartBubbleCount"]');
    if (el) {
      var n = parseInt((el.textContent || '').trim(), 10);
      if (!isNaN(n)) return n;
    }
    try {
      var ss = sessionStorage.getItem('cart-count');
      if (ss) {
        var m = parseInt(JSON.parse(ss).value, 10);
        if (!isNaN(m)) return m;
      }
    } catch (e) {}
    return 0;
  }

  function say(text, duration) {
    if (!bubble) return;
    clearTimeout(hideTimer);
    bubble.textContent = text;
    bubble.classList.remove('is-show');
    void bubble.offsetWidth; // restart transition
    bubble.classList.add('is-show');
    hideTimer = setTimeout(function () { bubble.classList.remove('is-show'); }, duration || 2600);
  }

  function hop(cb) {
    pipEl.classList.remove('is-hop');
    void pipEl.offsetWidth;
    pipEl.classList.add('is-hop');
    setTimeout(function () { pipEl.classList.remove('is-hop'); if (cb) cb(); }, 720);
  }

  var happyTimer;
  function showHappy() {
    // Switch to the seated/happy pose, give a gentle hop, then return to standing.
    clearTimeout(happyTimer);
    pipEl.classList.add('is-happy');
    hop();
    happyTimer = setTimeout(function () { pipEl.classList.remove('is-happy'); }, 2600);
  }

  function burst() {
    var glyphs = ['✦', '✿', '❀', '✧'];
    for (var i = 0; i < 5; i++) {
      (function (i) {
        var s = document.createElement('span');
        s.className = 'pip__spark';
        s.textContent = glyphs[i % glyphs.length];
        s.style.setProperty('--dx', (Math.random() * 46 - 23).toFixed(1) + 'px');
        s.style.left = (40 + Math.random() * 40) + '%';
        s.style.animationDelay = (i * 40) + 'ms';
        pipEl.appendChild(s);
        setTimeout(function () { s.remove(); }, 1000);
      })(i);
    }
  }

  function resetIdle() {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      if (!document.hidden && Math.random() < 0.5) hop();
      resetIdle();
    }, 45000);
  }

  // Click: little hop + sparkle. On a 404, Pip walks you home.
  pipEl.addEventListener('click', function (e) {
    if (closeBtn && e.target === closeBtn) return;
    if (pageType === '404') { window.location.href = homeUrl; return; }
    hop();
    burst();
    resetIdle();
  });

  // Dismiss — remembered across the session.
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      try { localStorage.setItem('fawn-mascot-hidden', '1'); } catch (er) {}
      pipEl.style.transition = 'transform .5s ease, opacity .5s ease';
      pipEl.style.transform = 'translateY(150px)';
      pipEl.style.opacity = '0';
      setTimeout(function () { root.remove(); }, 520);
    });
  }

  // Real add-to-cart: only celebrate when the count actually goes up.
  document.addEventListener('shopify:cart:lines-update', function () {
    setTimeout(function () {
      var c = readCartCount();
      if (c > lastCount) { showHappy(); burst(); say('added ✓', 2400); }
      lastCount = c;
    }, 350);
  });

  // Arrival hop on each page load; a tiny line only on 404.
  function arrive() {
    hop(function () {
      if (pageType === '404') setTimeout(function () { say('this way back', 3200); }, 160);
      resetIdle();
    });
  }

  if (document.readyState === 'complete') arrive();
  else window.addEventListener('load', function () { setTimeout(arrive, 350); });
})();
